import { configureStore, combineReducers } from "@reduxjs/toolkit";

// middleware
import reduxLogger from "redux-logger";
import webSocketMiddleware from "./WebSocket/WebSocketMiddleware.js";

// reducers
import TopBar from "./TopBar/reducer";
import Modal from "./Modal/reducer";
import Spinner from "./Spinner/reducer";
import Confirmations from "./Confirmations/reducer";
import CounterPartys from "./CounterPartys/reducer";
import Tx from "./Tx/reducer";
import { reducer as Toaster } from "./Toaster";
import Inventory from "./Inventory/reducer";
import Availability from "./Availability/reducer";
import Confirm from "./Confirm/reducer";
import Settings from "./Settings/reducer";
import Table from "./Table/reducer";
import Auth from "./Auth/reducer";
import MarketData from "./MarketData/reducer";
import FileManager from "./FileManager/reducer";
import Recall from "./Recall/reducer";
import ClientPool from "./ClientPool/reducer";
import Dashboard from "./Dashboard/reducer";
import Admin from "./Admin/reducer";
import Security from "./Security/reducer";

// combine our reducers
const combinedReducers = combineReducers({
    TopBar,
    Confirmations,
    Modal,
    CounterPartys,
    Auth,
    Tx,
    Toaster,
    Inventory,
    Availability,
    Confirm,
    Settings,
    Table,
    MarketData,
    Spinner,
    FileManager,
    Recall,
    ClientPool,
    Dashboard,
    Admin,
    Security,
});

// Default middleware included in redux toolkit
// https://redux-toolkit.js.org/api/getDefaultMiddleware#included-default-middleware
export default function initStore() {
    return configureStore({
        reducer: combinedReducers,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({ serializableCheck: false }).concat(
                reduxLogger,
                webSocketMiddleware("events")
            ),
    });
}
